import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { OktaService } from './okta.service';
import { environment } from '../../../environments/environment';

export interface TemplateElement {
    'id': string,
    'name': string
}

@Injectable()
export class TemplateService {
    templateList:BehaviorSubject<TemplateElement[] | null> = new BehaviorSubject<TemplateElement[] | null>(null);
    loadFailed = false;

    constructor( private http: HttpClient, private oktaService: OktaService ){};

    get templatesUpdated(): Observable<TemplateElement[] | null> {
        return this.templateList.asObservable();
    }

    refresh() {
        this.loadFailed = false;

        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        this.http.get<any>( environment.azure.url + '/admin.templates', options)
            .subscribe({
                next: data => {
                    let loadedTemplates: TemplateElement[] = [];
                    data.forEach((template:any) => {
                        loadedTemplates.push({
                            id: template.id,
                            name: template.name
                        });
                    });
                    this.templateList.next ( loadedTemplates );
                    this.loadFailed = false;
                },
                error: msg => { 
                    this.loadFailed = true;
                    this.templateList.next(null);
                    console.log( msg );
                }
            });
    }
}
